import React, { useState, useEffect } from 'react';
import TrueViewTable from './TrueViewTable';
import EmailStatusPage from './EmailStatusPage';
import LoginScreen from './LoginScreen';
import './App.css';

type PageType = 'trueview' | 'emailstatus';

function App() {
  const [selectedMonth, setSelectedMonth] = useState<string>('');
  const [selectedYear, setSelectedYear] = useState<string>('');
  const [monthLoading, setMonthLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState<PageType>('trueview');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userEmail, setUserEmail] = useState<string>('');

  const handleMonthChange = (month: string) => {
    setSelectedMonth(month);
    setMonthLoading(true);
    setTimeout(() => setMonthLoading(false), 100);
  };

  const handleYearChange = (year: string) => {
    setSelectedYear(year);
    setMonthLoading(true);
    setTimeout(() => setMonthLoading(false), 100);
  };

  const handleGoBack = () => {
    setSelectedMonth('');
    setSelectedYear('');
  };

  const handleNavigateToEmailStatus = () => {
    setCurrentPage('emailstatus');
  };

  const handleBackToTrueView = () => {
    setCurrentPage('trueview');
  };

  const handleLogin = (email: string) => {
    setUserEmail(email);
    setIsAuthenticated(true);
  };

  if (!isAuthenticated) {
    return <LoginScreen onLogin={handleLogin} />;
  }

  if (currentPage === 'emailstatus') {
    return <EmailStatusPage onGoBack={handleBackToTrueView} />;
  }

  return (
    <TrueViewTable 
      onGoBack={handleGoBack}
      onNavigateToEmailStatus={handleNavigateToEmailStatus}
    />
  );
}

export default App;
